import { componentMap as formComponentMap } from '@cainiaofe/cn-ui';
import { DisplayPosition } from '@/common/manager/position/display-position';
export const config = {
    position: [
        DisplayPosition.form,
        DisplayPosition.formDialog,
        DisplayPosition.cnArrayTable,
        DisplayPosition.cnArraySubAreaCard,
    ],
    componentName: 'Switch',
    formComponent: formComponentMap.CnSwitch,
};
